import { MutationTree } from "vuex";
import { ChatStateInterface } from "./state";
import EventBus from "src/services/event-bus";
import LocalDb from "src/services/db";

const mutation: MutationTree<ChatStateInterface> = {
  init(state, messages) {
    state.messages = messages;
  },

  push_message(state, message) {
    let i = state.messages?.findIndex((x) => x.guid == message.guid) ?? -1;
    if (i == -1) {
      i = state.messages?.findIndex((x) => x.id == message.id);
    }
    if (i == -1) {
      // console.log("NEW message", message);
      state.messages.push(message);
      if (!message.isEventItem) {
        EventBus.$emit("messageAdded", message);
      }
    } else {
      // console.log("SET message", message);
      state.messages[i] = message;
    }
  },

  addPreviousMessages(state, messages) {
    state.messages.unshift(...messages);
  },

  deleteMessages(state) {
    state.messages = [];
  },

  updateMessage(state, message) {
    const i = state.messages.findIndex((x) => x.id == message.id);
    if (i != -1) {
      state.messages[i] = message;
      LocalDb.then((db) => db.messages.updateMessage(message));
    }
  },

  updateMessageRecognizeAgain(state, { message, recognizeAgain }) {
    message.state.recognizeAgain = recognizeAgain;
  },

  deleteAudios(state, date) {
    LocalDb.then((db) => db.audio.clearAudios(date));
  },

  setAnswerRate(state, { message, rate }) {
    const i = state.messages.findIndex((x) => x.id == message.id);
    if (i != -1) {
      state.messages[i].rate = rate;
    }
    LocalDb.then((db) => db.messages.updateMessage(message));
  },
};

export default mutation;
